/******************************************************
 * Override in customer folder, to add custom widgets *
 *****************************************************/
const CUSTOM_WIDGETS_REGISTRY = Object.freeze([]);

export default CUSTOM_WIDGETS_REGISTRY;
